/**
 * PortalOnizlemeBandi.jsx — firma portalı ÖNİZLEMESİ açıkken her sayfanın üstündeki bant (backlog #411, 2026-10-13).
 *
 * Personel, Firma Detay'dan "Portalı bu firma olarak önizle" ile bir firmanın portalını seçili fuarda salt okunur açar
 * (services/portalOnizleme.js). Bant üç şeyi söyler: hangi firma, hangi arayüz seti, hangi fuar; ve hiçbir şeyin
 * kaydedilmediğini. "Önizlemeyi kapat" firmanın Firma Detay sayfasına döner. Önizleme yokken (ve firma girişinde) hiçbir şey çizmez.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { usePortal } from '../Contexts/PortalContext';
import { stopOnizleme, useOnizleme } from '../../services/portalOnizleme';

export default function PortalOnizlemeBandi() {
  const { t } = useTranslation('components');
  const portal = usePortal();
  const navigate = useNavigate();
  const onizleme = useOnizleme();
  if (!portal?.onizleme) return null;

  const firmaId = portal.firmaId;
  const firmaAdi = portal.firma?.firmaName || portal.onizlemeFirmaAdi || `#${firmaId ?? ''}`;
  const set = portal.aktif ? t(`portalOnizleme.arayuz.${portal.aktif.kod}`, { defaultValue: portal.aktif.ad }) : t('portalOnizleme.setYok');

  const geriAdresi = firmaId ? `/Management/Firmalar/Detay/${firmaId}` : '/Management/Firmalar/Kartlar';
  // WAS (until #739): const kapat = () => { stopOnizleme(); navigate(geriAdresi); };
  const kapat = () => {
    if (onizleme?.yeniSekme) {
      // #739: this tab was opened only for the preview: close it (the staff tab is still where the user left it).
      // The flag dies with the tab. When the browser refuses to close it (a restored tab), leave the preview in this tab instead.
      window.close();
      setTimeout(() => { stopOnizleme(); navigate(geriAdresi); }, 150);
      return;
    }
    stopOnizleme();
    navigate(geriAdresi);
  };

  return (
    <Alert color="warning" className="mx-3 mt-3 mb-0 d-flex flex-wrap align-items-center gap-2" data-testid="portal-onizleme-bandi">
      <i className="ri-eye-line fs-5" />
      <div className="flex-grow-1">
        <strong>{t('portalOnizleme.baslik')}</strong>{' '}
        {t('portalOnizleme.ozet', { firma: firmaAdi, set, fuarId: portal.fuarId ?? '—' })}{' '}
        {/* #417: "portalı bu kullanıcı olarak önizle": that login's own roles decide what shows */}
        {portal.onizlemeKullaniciAdi && (
          <span data-testid="portal-onizleme-kullanici">
            {t('portalOnizleme.kullanici', { kullanici: portal.onizlemeKullaniciAdi })}{' '}
          </span>
        )}
        <span className="text-muted">{t('portalOnizleme.salt')}</span>
      </div>
      <Button color="warning" size="sm" outline onClick={kapat} data-testid="portal-onizleme-kapat">
        {t('portalOnizleme.kapat')}
      </Button>
    </Alert>
  );
}
